import { makeStyles } from '@fluentui/react-components';

export const useHandoffDialogStyles = makeStyles({
  plannerListbox: {
    maxHeight: '21.75rem !important' as unknown as string,
  },
});
